var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDownloadExcel = function SvgDownloadExcel(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Ebene 1",
    viewBox: "0 0 11.5 11.5",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.64 11.5H1.86c-1 .03-1.83-.75-1.86-1.75v-2C0 7.34.34 7 .75 7s.75.34.75.75v2c0 .12.15.25.36.25h7.78c.21 0 .36-.13.36-.25v-2c0-.41.34-.75.75-.75s.75.34.75.75v2c-.03 1-.86 1.78-1.86 1.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 8.04a.74.74 0 0 1-.48-.17l-3-2.5A.748.748 0 0 1 3.2 4.2s.02.02.03.02l2.52 2.1 2.52-2.1c.32-.26.8-.2 1.05.12.25.31.21.77-.09 1.03l-3 2.5a.74.74 0 0 1-.48.17"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 7.5c-.41 0-.75-.34-.75-.75v-6c0-.41.34-.75.75-.75s.75.34.75.75v6c0 .41-.34.75-.75.75"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDownloadExcel);
export default ForwardRef;